import SideMenu from '../navigation/side-menu';
import AddToCartHandler from '../shared/product/add-to-cart-handler';
import AboveTheFoldSelectors from '../shared/above-the-fold/selectors';
import SubscriptionHandler from '../shared/product/subscription-handler';
import QuantityHandler from '../shared/above-the-fold/quantity-handler';
import VariantSelectDropdown from '../above-the-fold/variant-select-dropdown';
import { SELECTORS } from '../above-the-fold/constants';
import { ProductBarManager } from './product-bar-manager';

export default class PurchaseBarSideMenu {
  constructor(containerId, showButtonSelector, closeButtonId) {
    this.containerId = containerId;
    this.showButtonSelector = showButtonSelector;
    this.closeButtonId = closeButtonId;
  }

  sideMenu = new SideMenu();

  show = () => {
    this.sideMenu.show(this.containerId);
  };

  close = () => {
    this.sideMenu.hide(this.containerId);
  };

  initializeEventListeners = () => {
    const showButtons = document.querySelectorAll(this.showButtonSelector);
    const closeButton = document.getElementById(this.closeButtonId);

    if (showButtons.length) {
      showButtons.forEach((showButton) => showButton.addEventListener('click', this.show));
    }

    if (closeButton) {
      closeButton.addEventListener('click', this.close);
    }

    const container = document.getElementById(this.containerId);

    if (container) {
      const variantSwitcher = container.querySelector(`.${SELECTORS.VARIANT_SWITCHER}`);
      const productFlavorManager = new ProductBarManager(container);
      const selectors = new AboveTheFoldSelectors(container);
      const addToCartHandler = new AddToCartHandler(selectors, [container]);
      const subscriptionHandler = new SubscriptionHandler(container);
      const quantityHandler = new QuantityHandler([container]);

      productFlavorManager.initializeEventListeners();
      addToCartHandler.initializeEventListeners();
      subscriptionHandler.initializeEventListeners();
      quantityHandler.initializeEventListeners();

      if (variantSwitcher) {
        new VariantSelectDropdown(container, variantSwitcher).initializeEventListeners();
      }
    }
  };
}
